<script>
  import { onDestroy, onMount } from "svelte";
  import {
    activePlayer,
    computeAnalyserSignal,
    USE_WEBAUDIO,
  } from "../util/audio-players";
  import PlayButton from "./PlayButton.svelte";
  import LinkButton from "./LinkButton.svelte";
  import { LINK_EPISODES } from "../util/constants";

  let curPlayer = activePlayer;
  let curState;
  let running = false;
  let raf;
  const unsubPlayer = activePlayer.subscribe((c) => {
    curPlayer = c;
    curState = curPlayer ? curPlayer.state : null;
    if (curState) start();
    else stop();
  });
  onDestroy(unsubPlayer);

  let signal = [];
  onMount(() => {
    return () => {
      stop();
    };
  });

  function start() {
    if (running) return;
    // console.log("starting");
    running = true;
    cancelAnimationFrame(raf);
    raf = requestAnimationFrame(animate);
  }

  function stop() {
    if (!running) return;
    // console.log("stopping");
    running = false;
    cancelAnimationFrame(raf);
    raf = null;
  }

  function animate(timeElapsed = 0) {
    raf = requestAnimationFrame(animate);
    signal = computeAnalyserSignal(curPlayer, timeElapsed);
  }
</script>

{#if curState}
  <div class="container">
    <div class="label">
      <LinkButton inline to={`/${LINK_EPISODES}`}
        >EP {curPlayer.meta.episode}</LinkButton
      >
    </div>
    <div class="play-button-container">
      <PlayButton
        loading={curState && $curState.loading}
        playing={curState && $curState.playing}
        on:click={async (ev) => {
          ev.preventDefault();
          if (curPlayer) {
            // const context = getGlobalContext();
            // context.resume();
            curPlayer.trigger();
            curPlayer.toggle();
          }
        }}
      />
    </div>
    <div class="bars">
      {#each signal as bar}
        <div
          class="bar"
          style="--amount: {bar * 100}%;"
          class:smooth={!USE_WEBAUDIO}
        />
      {/each}
    </div>
  </div>
{/if}

<style>
  .container {
    display: flex;
    flex-direction: row;
    gap: 10px;
    justify-content: flex-start;
    align-items: center;
    box-sizing: border-box;
    flex-grow: 1;
    padding-left: 20px;
    padding-right: 20px;
    border-left: 1px dashed black;
    height: 100%;
    /* background: lightgray; */
  }
  .bars {
    display: flex;
    justify-content: flex-start;
    flex-direction: row;
    align-items: center;
    height: 25px;
    flex-shrink: 0;
    gap: 3px;
  }
  .bar {
    width: 2px;
    height: var(--amount);
    background: black;
    will-change: height;
    border-radius: 2px;
    min-height: 2px;
  }
  .bar.smooth {
    transition: height 0.05s linear;
  }
  .play-button-container {
    width: 32px;
    height: 32px;
    /* background: hsl(0, 0%, 85%); */
    /* border-radius: 1px; */
    /* border: 1px solid black; */
    padding: 0px;
    /* margin-left: 5px; */
    /* margin-right: 5px; */
    /* overflow: hidden; */
    box-sizing: border-box;
  }
  .label {
    flex-grow: 1;
    display: flex;
    flex-direction: row;
    font-size: 12px;
    flex-shrink: 0;
  }
</style>
